import Vue from 'vue'
import Router from 'vue-router'
import RouterConfig from './router.config'
import Utils from '../tools/utils'

Vue.use(Router)
Vue.prototype.Utils = Utils
const router = new Router({
  // mode: 'history',
  routes: [
    ...generateRoutes()
  ],
  // 页面跳转
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

function generateRoutes () {
  let data = sessionStorage.getItem('router')
  let routers = []
  routers.push({path: '/login', component: RouterConfig['login']})
  // routers.push({path: '/zhihuiLogin', component: RouterConfig['zhihuiLogin']})
  routers.push({path: '/404', component: RouterConfig['404']})
  // routers.push({ path: '*', component: RouterConfig['404'] })
  // if (data) {
  //   let rout = JSON.parse(data)
  //   let routerArr = Vue.prototype.Utils.dynamicRouter(rout)
  //   routers = routers.concat(routerArr)
  // }
  return routers
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js